import img1 from "./WhatsApp Image 2025-11-25 at 11.28.07 PM.jpeg";
import img2 from "./WhatsApp Image 2025-11-25 at 11.28.08 PM (1).jpeg";
import img3 from "./WhatsApp Image 2025-11-25 at 11.28.08 PM (2).jpeg";
import img4 from "./WhatsApp Image 2025-11-25 at 11.28.08 PM.jpeg";
import img5 from "./WhatsApp Image 2025-11-25 at 11.28.09 PM.jpeg";
import img6 from "./WhatsApp Image 2025-11-25 at 11.28.10 PM (1).jpeg";
import img7 from "./WhatsApp Image 2025-11-25 at 11.28.10 PM.jpeg";
import img8 from "./WhatsApp Image 2025-11-25 at 11.28.11 PM (1).jpeg";
import img9 from "./WhatsApp Image 2025-11-25 at 11.28.11 PM.jpeg";
import img10 from "./WhatsApp Image 2025-11-25 at 11.28.27 PM.jpeg";
import img11 from "./WhatsApp Image 2025-11-25 at 11.29.20 PM.jpeg";
import img12 from "./WhatsApp Image 2025-11-25 at 11.29.26 PM (1).jpeg";
import img13 from "./WhatsApp Image 2025-11-25 at 11.29.26 PM.jpeg";
import img14 from "./WhatsApp Image 2025-11-25 at 11.29.42 PM (1).jpeg";
import img15 from "./WhatsApp Image 2025-11-25 at 11.29.42 PM (2).jpeg";
import img16 from "./WhatsApp Image 2025-11-25 at 11.29.42 PM.jpeg";
import img17 from "./WhatsApp Image 2025-11-25 at 11.29.43 PM (1).jpeg";
import img18 from "./WhatsApp Image 2025-11-25 at 11.29.43 PM (2).jpeg";
import img19 from "./WhatsApp Image 2025-11-25 at 11.29.43 PM.jpeg";
import img20 from "./WhatsApp Image 2025-11-25 at 11.29.44 PM (1).jpeg";
import img21 from "./WhatsApp Image 2025-11-25 at 11.29.44 PM (2).jpeg";
import img22 from "./WhatsApp Image 2025-11-25 at 11.29.44 PM.jpeg";
import img23 from "./WhatsApp Image 2025-11-25 at 11.29.45 PM (1).jpeg";
import img24 from "./WhatsApp Image 2025-11-25 at 11.29.45 PM (2).jpeg";
import img25 from "./WhatsApp Image 2025-11-25 at 11.29.45 PM (3).jpeg";
import img26 from "./WhatsApp Image 2025-11-25 at 11.29.45 PM.jpeg";
import img27 from "./WhatsApp Image 2025-11-25 at 11.29.46 PM (1).jpeg";
import img28 from "./WhatsApp Image 2025-11-25 at 11.29.46 PM (2).jpeg";
import img29 from "./WhatsApp Image 2025-11-25 at 11.29.46 PM.jpeg";
import img30 from "./WhatsApp Image 2025-11-25 at 11.29.47 PM (1).jpeg";
import img31 from "./WhatsApp Image 2025-11-25 at 11.29.47 PM.jpeg";
import img32 from "./WhatsApp Image 2025-11-25 at 11.29.48 PM.jpeg";
import img33 from "./WhatsApp Image 2025-11-25 at 11.29.49 PM (1).jpeg";
import img34 from "./WhatsApp Image 2025-11-25 at 11.29.49 PM.jpeg";
import img35 from "./WhatsApp Image 2025-11-25 at 11.29.50 PM.jpeg";
import img36 from "./WhatsApp Image 2025-11-25 at 11.29.51 PM.jpeg";
import img37 from "./WhatsApp Image 2025-11-25 at 11.29.53 PM.jpeg";
import img38 from "./WhatsApp Image 2025-11-25 at 11.29.55 PM.jpeg";
import img39 from "./WhatsApp Image 2025-11-25 at 11.29.57 PM.jpeg";
import img40 from "./WhatsApp Image 2025-11-25 at 11.29.58 PM (1).jpeg";
import img41 from "./WhatsApp Image 2025-11-25 at 11.29.58 PM (2).jpeg";
import img42 from "./WhatsApp Image 2025-11-25 at 11.29.58 PM.jpeg";
import img43 from "./WhatsApp Image 2025-11-25 at 11.29.59 PM (1).jpeg";
import img44 from "./WhatsApp Image 2025-11-25 at 11.29.59 PM.jpeg";
import img45 from "./WhatsApp Image 2025-11-25 at 11.30.01 PM (1).jpeg";
import img46 from "./WhatsApp Image 2025-11-25 at 11.30.01 PM (2).jpeg";
import img47 from "./WhatsApp Image 2025-11-25 at 11.30.01 PM.jpeg";
import img48 from "./WhatsApp Image 2025-11-25 at 11.30.02 PM (1).jpeg";
import img49 from "./WhatsApp Image 2025-11-25 at 11.30.02 PM (2).jpeg";
import img50 from "./WhatsApp Image 2025-11-25 at 11.30.02 PM (3).jpeg";
import img51 from "./WhatsApp Image 2025-11-25 at 11.30.02 PM.jpeg";
import img52 from "./WhatsApp Image 2025-11-25 at 11.30.03 PM (1).jpeg";
import img53 from "./WhatsApp Image 2025-11-25 at 11.30.03 PM (2).jpeg";
import img54 from "./WhatsApp Image 2025-11-25 at 11.30.03 PM (3).jpeg";
import img55 from "./WhatsApp Image 2025-11-25 at 11.30.03 PM.jpeg";
import img56 from "./WhatsApp Image 2025-11-25 at 11.30.04 PM.jpeg";

export default [
  img1,
  img2,
  img3,
  img4,
  img5,
  img6,
  img7,
  img8,
  img9,
  img10,
  img11,
  img12,
  img13,
  img14,
  img15,
  img16,
  img17,
  img18,
  img19,
  img20,
  img21,
  img22,
  img23,
  img24,
  img25,
  img26,
  img27,
  img28,
  img29,
  img30,
  img31,
  img32,
  img33,
  img34,
  img35,
  img36,
  img37,
  img38,
  img39,
  img40,
  img41,
  img42,
  img43,
  img44,
  img45,
  img46,
  img47,
  img48,
  img49,
  img50,
  img51,
  img52,
  img53,
  img54,
  img55,
  img56,
];
